module.exports = __webpack_public_path__ + "img/plus2.bb4e6e2c.svg";